import { Result, Task } from 'constants/interfaces'
import keys from 'constants/keys'

export interface IRatingFeedback {
  id: number
  rating: number
}

export interface IReviewFeedback {
  id: number
  kind: 'approved' | 'rejected'
}

export const getReviewState = (result?: Result) => ({
  isApproved:
    result?.status === keys.TASK_STATUSES.APPROVED.value ||
    result?.status === keys.TASK_STATUSES.APPROVED_WITH_RESERVATION.value,
  isApprovedWithReservation: result?.status === keys.TASK_STATUSES.APPROVED_WITH_RESERVATION.value,
  isRejected: result?.status === keys.TASK_STATUSES.DISAPPROVED.value,
})

export const hasReachedReworkLimit = (limit: Task['rework_limit'], count: number) =>
  typeof limit === 'number' && Number.isFinite(limit) && count >= limit

export const canReviewMediaResult = (
  task: Task,
  uid: string | null | undefined,
  isReadMode: boolean,
  result?: Result
) =>
  !!task.is_required_approval &&
  isReadMode &&
  !!uid &&
  !!task.auditors?.includes(uid) &&
  !!result &&
  result.status !== keys.TASK_STATUSES.REVIEWED_BY_AI.value &&
  [
    keys.TASK_STATUSES.DONE.value,
    keys.TASK_STATUSES.DISAPPROVED.value,
    keys.TASK_STATUSES.APPROVED.value,
    keys.TASK_STATUSES.APPROVED_WITH_RESERVATION.value,
  ].includes(result.status)
